export default __webpack_public_path__ + "static/media/architecturals.95169c95.jpg";